import { reactive, not } from 'alkali'
import { Button, P, Span, Div, A } from 'alkali'
import { view as analysisView } from 'model/Analysis'
import { counts, hasScreeningAccess } from 'model/Screening'
import { analysisType, structuredQuery, currentAnalysisSelections, selectedStudies, questionAsParameters } from 'model/SearchQuery'
import { studyDetailsPane } from './StudyDetailsPane'
import '../screening/ScreeningDialog'
import { activeTab, studyStats, flagFiltered, selectedStudyData, getFocusedStudy, tabFilter } from 'model/StudyCollection'
import { tourRunner, quickAnalysisMap } from '../entry/Tour'
import './StudiesTabs.scss'
import { inferExtractState } from 'components/extract/model/extraction'
import app from '../../app/app'
import { StudyAnalysisModel } from 'model/AnalyzeStudy'

export const hasExtractAccess = reactive(app.user).to(user => !!user?.FeatureConfig?.['Rapid Extract']?.Enabled)

export async function switchToScreeningTab() {
	activeTab.put('screening')
	studyDetailsPane.showStudy(await getFocusedStudy())
	tabFilter.put('')
}

export async function switchToExtractTab() {
	activeTab.put('extract')
	const study = await getFocusedStudy()
	tabFilter.put('')

	let studyAnalysisModel = new StudyAnalysisModel(study)
	let { currentPublication, outcome } = studyAnalysisModel
	let groups = currentPublication.property('groups')

	const extractState = inferExtractState(study, groups, outcome, app.user)
	studyDetailsPane.showStudy(study, extractState, true)
}
export class StudiesTabs extends Div('.studies-tabs') {
	ready({ evidenceResults }) {
		const hasData = analysisType.to(type => type == 'evidence-table' ? selectedStudies.to(studies => studies?.length > 0) :
			selectedStudyData.to((studies) => studies.some((study) => study.cells.length > 0)))
		this.append(
			Button('#sources.active.study-tab', {
				classes: { 'current-tab' : activeTab.to(tab => tab == 'sources') },
				content: P('.tab-title', ['Search Results', Span('.tab-number', [
					studyStats.to(({digitizedCount, undigitizedCount, groupedCount }) => {
						let total = digitizedCount + undigitizedCount - groupedCount
						return isNaN(total) ? '...' : total
					})
				])]),
				onclick() {
					activeTab.put('sources')
					studyDetailsPane.hide()
					tabFilter.put('')
				},
			}),
			Button('#screening.active.study-tab', {
				classes: { 'current-tab' : activeTab.to(tab => tab == 'screening') },
				display: hasScreeningAccess,
				content: P('.tab-title', [
					'Screening',
					Span('.tab-number', {
						content: counts.to(({ toScreen }) => isNaN(toScreen) ? '...' : toScreen )})]),
				async onclick() {
					switchToScreeningTab()
				},
			}),
			Button('#extract.active.study-tab', {
				display: hasExtractAccess,
				classes: { 'current-tab' : activeTab.to(tab => tab == 'extract') },
				content: P('.tab-title', ['Extract', Span('.tab-number', {
					content: counts.to(({ toExtract }) => isNaN(toExtract) ? '...' : toExtract )})]),
				async onclick() {
					switchToExtractTab()
				},
			}),
			Button('#selected.active.study-tab', {
				display: analysisType.to(type => type != 'evidence-table'),
				classes: { 'current-tab' : activeTab.to(tab => tab == 'analyzable') },
				content: P('.tab-title', ['Analyzable', Span('.tab-number', [ counts.to(({ analyzable }) => isNaN(analyzable) ? '...' : analyzable ) ])]),
				onclick() {
					activeTab.put('analyzable')
					studyDetailsPane.hide()
					tabFilter.put('')
				},
			}),
			Button('#analysis.active.study-tab', {
				display: analysisType.to((analysisType) => analysisType != 'evidence-table'),
				classes: { 'current-tab': activeTab.to(tab => tab == 'report') },
				disabled: not(hasData),
				content: [P('.tab-title', [ isFAQDashboard ? 'View Analysis' : 'Run Analysis']),
				Span('.tab-number', [ selectedStudyData.to(studies => studies.length ) ])],
				onclick() {
					// Navigate to RunQuickAnalysis if user is currently in the tour
					if (document.querySelector('.quick-analysis-analyzable')) {
						setTimeout(() => {
							tourRunner(quickAnalysisMap, 3)
						}, 1000)
					}
					evidenceResults.showAnalysis()
					activeTab.put('report')
					tabFilter.put('')
					document.querySelector('.studies-tabs').classList.add('report-view')
					studyDetailsPane.hide()
				},
			}),
			Button('#evidence-table.run-analysis.study-tab', {
				display: analysisType.to((analysisType) => analysisType == 'evidence-table'),
				content: [A('.tab-title', ['Report'], {href: structuredQuery.to(() => currentAnalysisSelections.to(({ analysisType }) => questionAsParameters().then(parameters =>
					'/portal/analysis/evidenceTableReport?' + parameters))),
					target: '_blank'}),
				Span('.tab-number', [ selectedStudies.length ])],
				disabled: not(hasData),
				onclick(event) {
					if (!hasData.valueOf())
						event.preventDefault()
				}
			})
		)
		switch (activeTab) {
			case 'screening':
			  getFocusedStudy().then(focusedStudy => studyDetailsPane.showStudy(focusedStudy))
			  break;
			case 'extract':
			  getFocusedStudy().then(focusedStudy => studyDetailsPane.showStudy(focusedStudy, true))
			  break;
		}
	}
}
